import React, { Fragment } from 'react';
import { Flex } from 'rebass';

import { Text } from '../Base';
import { FONT_SIZE, SPACE } from '../Theme';
import { MAJOR_OPTIONS } from '../../Components/AddPersonalInformation/AddPersonalInformation';

const getMajorText = majorText => {
  const targetMajor = MAJOR_OPTIONS.find(majorOption => majorOption.value === majorText);
  if (targetMajor) {
    return targetMajor.text;
  } else {
    return '';
  }
};

const FieldData = ({ label, value }) => {
  return (
    <Flex mt={SPACE.medium}>
      <Flex width={2 / 5} pt={SPACE.small} pr={SPACE.small}>
        <Text fontWeight="500" fontSize={FONT_SIZE.normal}>
          {label}
        </Text>
      </Flex>
      <Flex width={3 / 5} pt={SPACE.small} justifyContent="flex-start">
        <Text fontWeight="300" fontSize={FONT_SIZE.normal}>
          {value}
        </Text>
      </Flex>
    </Flex>
  );
};

const DataForm = ({ profile }) => (
  <Fragment>
    <FieldData label="โรงเรียน" value={profile.locationName || ''} />
    <FieldData label="ชื่อ" value={profile.firstName || ''} />
    <FieldData label="นามสกุล" value={profile.lastName || ''} />
    <FieldData label="แผนการเรียน" value={getMajorText(profile.major)} />
    <FieldData label="รหัสนักเรียน" value={profile.studentCode || ''} />
    <FieldData label="เลขบัตรประชาชน" value={profile.ssid || ''} />
    <FieldData label="เบอร์โทรศัพท์" value={profile.phone || ''} />
    <FieldData label="อีเมล" value={profile.email || ''} />
  </Fragment>
);

export default DataForm;
